import React from 'react';
import {Modal, Tabs} from "antd";
import {injectIntl} from "react-intl";
import BoldText from "../../common/text/BoldText";
import LabeledText from "../../common/text/LabeledText";
import {withAuthorization} from "../../../services/Authorization";
import DeliveryModalTab from "./DeliveryModalTab";
import ReturnModalTab from "./ReturnModalTab";
import connect from "react-redux/es/connect/connect";
import SAInputComponent from "../../common/input/SAInputComponent";
import DateFormat from "../../common/format/DateFormat";
import moment from 'moment';
import Constants from "../../../services/Constants";

const TabPane = Tabs.TabPane;

class RentalReportingModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      deliveryReport: {...this.initReport()},
      returnReport: {...this.initReport()},
      identityDocuments: {...this.initReport()},
      identityData: props.identityData
    }
  }

  initReport = () => {
    return {
      fileList: {
        attachments: [],
      },
      outdatedFiles:[]
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.identityDocuments) {
      let {attachments = []} = nextProps.identityDocuments;
      attachments = attachments.map(a => ({uid: a.key}));
      this.setState({identityDocuments: {...this.initReport(), attachments}});
    }

    if (nextProps.identityData) {
      this.setState({identityData: nextProps.identityData});
    }


    if (nextProps.reporting) {
      const {defaultActiveReport, reporting: {deliveryReport, returnReport, canBeDelivered, canBeReturned}} = nextProps;
      const delivery = this.mapAttachmentsToPicture(deliveryReport);
      const returning = this.mapAttachmentsToPicture(returnReport);
      const activeReport = (canBeDelivered) ? "deliveryReport" : "returnReport";

      const returnExecuted = (returnReport && returnReport.executionDate) || moment();
      this.setState({
        canBeDelivered, canBeReturned,
        activeReport: defaultActiveReport ? defaultActiveReport : activeReport,
        deliveryReport: {...this.initReport(), ...delivery},
        returnReport : {
          returnDate: moment(returnExecuted).format(Constants.DATE_FORMAT_API),
          returnTime: moment(returnExecuted).format(Constants.TIME_FORMAT_API),
          ...this.initReport(),
          ...returning,
        }
      });
    }
  }

  mapAttachmentsToPicture = (report = {}) => {
    const reportCopy = Object.assign({}, report);
    if (reportCopy.attachments) {
      reportCopy.attachments = reportCopy.attachments.map(a => ({uid: a.key, url: a.url}));
    }
    return reportCopy;
  };

  handleAttachmentsChange = ({fileList}) => {
    const selectedReport = this.state[this.state.activeReport];
    selectedReport.attachments = fileList;
    this.setState({[this.state.activeReport]: selectedReport});
  };

  onPaneChange = (key) => {
    this.setState({activeReport: key});
  };

  onReportSave = () => {
    const {rentalDetails: {id}} = this.props;

    const {activeReport} = this.state;
    const selectedReport = this.state[activeReport];
    const {fileList: {attachments}, mileage, fuel, advisorComment, outdatedFiles, returnDate, returnTime} = selectedReport;

    const form = new FormData();
    attachments && attachments.forEach((file) => {
      form.append('attachments', file)
    });

    mileage && form.append("mileage", mileage);
    fuel && form.append("fuel", fuel);
    advisorComment !== undefined && form.append("comment", advisorComment);
    form.append("outdatedFiles", outdatedFiles);

    if (activeReport === 'deliveryReport') {
      this.onIdentityDocumentsSave();
      this.props.dispatchDeliverRental(id, form)
    } else {
      form.append("returnDate", returnDate);
      form.append("returnTime", returnTime);
      this.props.dispatchReturnRental(id, form);
    }
  };

  onIdentityDocumentsSave = () => {
    const {rentalDetails: {rentingJourney:{customer: {id}}}, journeyUuid} = this.props;
    const {identityDocuments: {fileList: {attachments} = {}, outdatedFiles} = {}} = this.state;

    if ((attachments && attachments.length > 0) || (outdatedFiles && outdatedFiles.length > 0)) {
      const form = new FormData();
      attachments.forEach((file) => {
        form.append('photos', file)
      });
      form.append("outdatedFiles", outdatedFiles);

      this.props.dispatchUpdateJourneyIdentityDocuments({uuid: journeyUuid, connectedUserId: id, body: form});
    }
  };

  onReportUpdate = (name, data) => {
    this.setState({[name]: data});
  };

  onIdentityDocumentsUpdate = (identityDocuments) => {
    this.setState({identityDocuments})
  };

  render() {
    const {intl: {formatMessage}, onModalClose, visible, deliverRentalVehicle, returnRentalVehicle} = this.props;
    const {rentalVehicle, rentalDetails, contract} = this.props;
    const {deliveryReport, returnReport, activeReport, canBeDelivered, canBeReturned, identityDocuments, identityData} = this.state;

    const deliveryError = deliverRentalVehicle.error && deliverRentalVehicle.error.content;
    const returnError = returnRentalVehicle.error && returnRentalVehicle.error.content;

    if (!rentalVehicle || !rentalDetails) {
      return null;
    }

    const {rentingJourney:{customer = {}, vehicle = {}}} = rentalDetails;
    return (
      <Modal title={formatMessage({id: 'section.car-delivery.modal.title'})}
             visible={visible} onCancel={onModalClose} width='120rem' onOk={this.onReportSave}>

        <div className="row">
          <ul className="list col-md-4 col-xxl-4">
            <h3 className="box__subtitle">{formatMessage({id:'summary.customer'})}</h3>
            <li><LabeledText label={'summary.customer'} text={`${customer.firstName} ${customer.lastName}`}/></li>
            <li><LabeledText label={'summary.phone'} text={customer.phone}/></li>
            <li><LabeledText label={'vehicle.vin'} text={<BoldText text={vehicle.vin} boldEndCharacters={7}/>}/></li>
          </ul>
          <ul className="list col-md-4 col-xxl-4">
            <h3 className="box__subtitle">{formatMessage({id:'mobility.rental-car'})}</h3>
            <li><LabeledText label={'vehicle.make'} text={rentalVehicle.brand}/></li>
            <li><LabeledText label={'vehicle.model'} text={rentalVehicle.model}/></li>
            <li><LabeledText label={'vehicle.vin'} text={<BoldText text={rentalVehicle.vin} boldEndCharacters={7}/>}/></li>
            <li><LabeledText label={'vehicle.category'} text={formatMessage({id: `mobility.${rentalVehicle.category}`})}/></li>
            <li><LabeledText label={'vehicle.gearbox'} text={formatMessage({id: `vehicle.gearbox.${rentalVehicle.gearbox}`})}/></li>
            <li><LabeledText label={'vehicle.plate'} text={rentalVehicle.licensePlate}/></li>
          </ul>
          <ul className="list col-md-4 col-xxl-4">
            {contract &&
              <div>
                <h3 className="box__subtitle">{formatMessage({id: 'appointment.detail.contract-dates.title'})}</h3>
                <li>
                  <SAInputComponent label={formatMessage({id: 'placeholder.startDate'})}>
                    <DateFormat className="ml-1" layout={"dateTimeLong"} date={contract.contractStart}/>
                  </SAInputComponent>
                </li>
                <li>
                  <SAInputComponent label={formatMessage({id: 'placeholder.endDate'})}>
                    <DateFormat className="ml-1" layout={"dateTimeLong"} date={contract.contractEnd}/>
                  </SAInputComponent>
                </li>
              </div>
            }
          </ul>
        </div>

        <Tabs type="card" activeKey={activeReport} onChange={this.onPaneChange}>
          <TabPane tab={formatMessage({id: 'vehicle.report.delivery'})} key="deliveryReport" disabled={!canBeDelivered}>
            <DeliveryModalTab name="deliveryReport" deliveryReport={deliveryReport} identityDocuments={identityDocuments} identityData={identityData}
                              onReportUpdate={this.onReportUpdate} onIdentityDocumentsUpdate={this.onIdentityDocumentsUpdate} errors={deliveryError}/>
          </TabPane>
          <TabPane tab={formatMessage({id: 'vehicle.report.return'})} key="returnReport" disabled={!canBeReturned}>
            <ReturnModalTab name="returnReport" returnReport={returnReport} onReportUpdate={this.onReportUpdate} errors={returnError}/>
          </TabPane>
        </Tabs>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  deliverRentalVehicle: state.deliverRentalVehicle,
  returnRentalVehicle: state.returnRentalVehicle
});

const mapDispatchToProps = dispatch => ({
  dispatchUpdateJourneyIdentityDocuments : (params) => dispatch({type: 'UPDATE.JOURNEY_IDENTITY_DOCUMENTS.REQUEST', ...params}),
  dispatchDeliverRental: (rentalDetailsId, body) => dispatch({type: 'DELIVER_RENTAL_VEHICLE.REQUEST', rentalDetailsId, body}),
  dispatchReturnRental: (rentalDetailsId, body) => dispatch({type: 'RETURN_RENTAL_VEHICLE.REQUEST', rentalDetailsId, body}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(RentalReportingModal), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/carpark/delivery/RentalReportingModal.js